// extracted by mini-css-extract-plugin
export default {"menuElement":"style_menuElement__O46xk","newImg":"style_newImg__mCPpP","disabled":"style_disabled__Zzfn-"};